import { jsx as _jsx } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
function Maintenance() {
    return (_jsx(Stack, { height: "100cqh", justifyContent: "center", alignItems: "center", gap: 1, children: _jsx(Typography, { variant: "h4", children: "Maintenance in progress, please try again later" }) }));
}
export default Maintenance;
